import React from 'react';
import TextBlock from '../Components/TextBlock';


const H6 = (props) => {
  return (
		<TextBlock name='Зміна відомостей про ФОП'>
			<section className="s-text">
				Відповідно до законодавства, якщо у ФОП відбулася зміна адреси, ПІБ або видів діяльності, то підприємець зобов'язаний повідомити про це державні органи.<br/>
                Ми внесемо зміни у найкоротші терміни, при цьому Вам не потрібно буде відвідувати державні органи та вистоювати черги.
			</section> 
			<section className="s-textb"> 
				Вартість послуги – від 500 грн.<br/>
				Строк виконання 1-3 робочі дні
			</section>  
			<section className="s-text">
			Для проведення реєстрації припинення підприємницької діяльності можуть знадобитися:<br/>
							- паспортні відомості та ідентифікаційний номер; <br/>
							- електронний цифровий підпис, або застосунок "Дія", або нотаріально посвідчена довіреність на реєстрацію ФОП, або особиста присутність. <br/>
							Реєстрацію можна провести як в нашому офісі так і онлайн. <br/>
							
			</section>  
		</TextBlock>
  );
}

const H7 = (props) => {
  return (
		<TextBlock name='Зареєстровані ТОВ з ПДВ'>
		<section className="s-text">
		<p>Плануєте укласти угоду, але не маєте часу на реєстрацію ТОВ та отримання статусу платника ПДВ? Ми 
    пропонуємо рішення – готові фірми з ПДВ.<br/></p>
		<p>Ці фірми абсолютно чисті, вони відкриті спеціально для продажу і не проводили жодних операцій. При перереєстрації можна змінити будь-які відомості, включаючи адресу, розмір статутного фонду та назву.</p>
		</section> 
		<section className="s-textb">
			ТОВ з ПДВ – 5000 гривен.<br/>
			Послуга включає підготовку і подачу документів для перереєстрації.<br/>
			Додатково сплачуються державний збір і послуги нотаріуса, вартість залежить від кількості нових власників. <br/>
			Строк переоформлення – 2-5 робочих днів. 
		</section>
		<section className="s-textb">
			Додаткові послуги: <br/>
			Супровід при відкриті рахунку в банку – 1000 грн.<br/>
			Допомога в отримані электронного цифрового підпису – 1000 грн.<br/>
			Юридична адреса.<br/>
			Печатка – 600 грн.
		</section>
		</TextBlock>
  );
}

const H8 = (props) => {
  return (
		<TextBlock name='Податкова звітність ФОП'>
			<section className="s-text">
			Підприємці зобов'язані сплачувати податки і збори, вести товарний та кадровий облік, подавати звіти,  дотримуватись касової дисципліни та виконувати інші передбачені законодавством обов'язки. Щоб запобігти штрафних санкцій та зберегти ваш час і спокій, ми пропонуємо скористатися професійними бухгалтерськими та кадровими послугами. <br/><br/>

                
- Бухгалтерський супровід від 500 грн./місяць.<br/>
- Підготовка та подання звітів від 600 грн.<br/>
- Оформлення найманих працівників від 1500 грн.<br/>
-	Реєстрація РРО/ПРРО 1500 грн. <br/>
-	Проведення звірки зі сплати податків від 500 грн. <br/>

			</section> 
			
		</TextBlock>
  );
}

const H9 = (props) => {
  return (
		<TextBlock name='Послуга з подання та оновлення інформації про бенефіціарів'>
			<section className="s-text">
				Законодавством передбачено, що юридичні особи, що зареєстровані на території України, мають подати структуру власності та відомості про бенефіціарів.
				Починаючи з 2022 року юридичні особи, щорічно, протягом 14 днів з дати реєстрації (дня народження) фірми, зобов'язані підтверджувати, що структура власності не змінилася. <br/>
				Штраф за порушення від 17000 до 51000 грн.<br/><br/>
				Вартість послуги залежить від кількості засновників і складності структури власників.<br/><br/>
				Ціна для ТОВ з київською адресою і одним-двома засновниками фізичними особами:<br/>
				Підготовка документів – 1000 грн.<br/>
				Подача документів державному реєстратору – 1500 грн.<br/>
				Срок 1-2 робочі дні.<br/>
				
			</section> 
		</TextBlock>
  );
}


export { H6, H7, H8, H9 };


// WEBPACK FOOTER //
// ./src/Page/H6-H9.jsx